module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('md-sidenav', {
    ref: "sidenav",
    staticClass: "md-left"
  }, [(_vm.user) ? _c('div', {
    staticClass: "bg-blue px2 pb2 pt4"
  }, [_c('div', {
    staticClass: "fz24"
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.store.name))])]) : _vm._e(), _vm._v(" "), _c('md-list', {
    nativeOn: {
      "click": function($event) {
        _vm.$refs.sidenav.close()
      }
    }
  }, [_c('md-list-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'shop'
      },
      "ex": ""
    }
  }, [_vm._v("Nettbutikk")])], 1), _vm._v(" "), _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_vm._v("Innstillinger")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "border-bottom border-light-grey"
  }), _vm._v(" "), _c('md-list', {
    nativeOn: {
      "click": function($event) {
        _vm.$refs.sidenav.close()
      }
    }
  }, [_c('md-list-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'logout'
      }
    }
  }, [_vm._v("Logg ut")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toolbar"
    }
  }, [_c('md-theme', {
    attrs: {
      "md-name": "white"
    }
  }, [_c('md-toolbar', {
    staticClass: "sh2"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-auto center"
  }, [_c('img', {
    staticClass: "mr1",
    attrs: {
      "src": "/static/img/ui/copy_print_logo.svg",
      "alt": "MyOrder",
      "width": "110"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mr2"
  }, [_c('md-button', {
    staticClass: "md-icon-button md-has-notification text-grey",
    nativeOn: {
      "click": function($event) {
        _vm.viewCart()
      }
    }
  }, [_c('md-tooltip', [_vm._v("Handlekurv")]), _vm._v(" "), (_vm.$root.$data.cart) ? _c('md-notification', {
    staticClass: "md-blue"
  }, [_vm._v(_vm._s(_vm.$root.$data.cart.items.length))]) : _vm._e(), _vm._v(" "), _c('md-icon', [_vm._v("shopping_cart")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e932972","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/views/templates/Main.vue
// module id = 645
// module chunks = 1